export const CONVERSION_ERROR = {
  DESCRIPTION: "Factor to multiply by, in order to convert from ",
};

export const MODAL_REPROCESS_ERRORS = {
  UNIT_ERROR: {
    INSTRUCTIONS: "This price uses a unit that was never used in the system before, please complete the next fields",
    TITLE: "Unit not found",
  },
  CONVERSION_ERROR: {
    INSTRUCTIONS:
      "This price uses a unit that lacks a conversion factor to the unit of it’s corresponding grazianos item, please complete the factor field with the corresponding information",
    TITLE: "Unit could not be converted",
  },
  LACKS_REFERENCE_ERROR: {
    INSTRUCTIONS: "Select the associated item from Grazianos",
    TITLE: "This vendor code does not have a reference to a graziano's item",
    HELPER_MSG: "If this product doesn't have a corresponding item in the grazianos database, please ",
    SECOND_HELPER_MSG: "create the new item in the admin page",
    THIRD_HELPER_MSG: ", select it here and complete the rest of the fields to reprocess the price",
  },
  DEFAULT_ERROR: {
    INSTRUCTIONS: "Please review the information and re-upload the spreadsheet",
    TITLE: "The item information couldn’t be processed",
  },
  WARNING: "Only numbers please",
};

export const UNIT_ERROR = {
  DESCRIPTION: "Select the base unit of the system that mostly resembles to ",
  EXAMPLE: 'e.g., "dzn" mostly resembles to "unit"',
  GUIDE: (missingUnit, normalized_unit) =>
    `Factor to multiply or divide by, in order to convert from  ${missingUnit} to ${normalized_unit}`,
};
